export enum CastTech {
  AirPlay = 'AirPlay',
  WebSocket = 'WebSocket',
  GoogleCast = 'GoogleCast',
}
